import React from 'react';
import { Text } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';
import paymentSuccessImage from 'images/payment/payment_success.webp';

/**
 * PaymentSuccessConfirmation component.
 *
 * Displays a success confirmation screen after a successful payment deposit.
 * Shows a payment success illustration with confirmation messages.
 *
 * @returns {JSX.Element} The rendered payment success confirmation component.
 */
const PaymentSuccessConfirmation = () => {
  const { t } = useTranslation('purchase');

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex flex-col items-center max-w-lg w-full">
        <div className="mb-8">
          <img src={paymentSuccessImage} alt="" className="w-48 h-auto md:w-64" />
        </div>

        <div className="mb-6 text-center">
          <Text size="XXL" weight="semibold" color="primary" mobileSize="XL">
            {t('payment_success.title')}
          </Text>
        </div>

        <div className="text-center">
          <Text size="L" color="grayMedium" mobileSize="M">
            <span className="font-semibold">{t('payment_success.returning_message')}</span>{' '}
            {t('payment_success.manual_close_message')}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessConfirmation;
